import axios from "axios";

const sendCode = () => axios.put(`/personal/api/sms/send_code`);

const verifyCode = (pass) => axios.put(`/personal/api/sms/verify_code`, { passcode: pass });

const getStartTime = () => axios.get(`/personal/api/sms/conf/timing`);

export default {
    sendCode,
    verifyCode,
    getStartTime
}